export default __webpack_public_path__ + "static/media/back00.e6b309aa.jpg";